import React, { useEffect, useRef } from "react";
import Stack from "react-stackai";
import { Analytics } from "@vercel/analytics/react"
import "./FullPageScroll.css";
import Navbar from "./pages/Home";
import Footer from "./pages/footer";
import Sobremi from "./pages/sobremi/section";
import TrabajosSection from "./pages/trabajos/section";
import TrabajosSection1 from "./pages/trabajos/section1";
import TrabajosSection2 from "./pages/trabajos/section2";


const sections = [
  <Navbar />, 
  <Sobremi />, 
  <TrabajosSection />, 
  <TrabajosSection1 />, 
  <TrabajosSection2 />, 
  <Footer />
];

const FullPageScroll = () => {
  const containerRef = useRef(null);
  const touchStartY = useRef(0);
  const touchEndY = useRef(0);

  useEffect(() => {
    const container = containerRef.current;

    const handleWheel = (event) => {
      event.preventDefault();
      container.scrollBy({ top: event.deltaY, behavior: "smooth" });
    };

    const handleTouchStart = (event) => {
      touchStartY.current = event.touches[0].clientY;
    };

    const handleTouchMove = (event) => {
      touchEndY.current = event.touches[0].clientY;
      const deltaY = touchStartY.current - touchEndY.current;
      container.scrollBy({ top: deltaY, behavior: "smooth" });
      touchStartY.current = touchEndY.current;
    };

    if (container) {
      container.addEventListener("wheel", handleWheel, { passive: false });
      container.addEventListener("touchstart", handleTouchStart, { passive: true });
      container.addEventListener("touchmove", handleTouchMove, { passive: false });
    }

    return () => {
      if (container) {
        container.removeEventListener("wheel", handleWheel);
        container.removeEventListener("touchstart", handleTouchStart);
        container.removeEventListener("touchmove", handleTouchMove);
      }
    };
  }, []);

  return (
    <div ref={containerRef} className="scroll-container bg-black overflow-y-auto h-screen">
      <Stack project="https://www.stack-ai.com/embed/34027e59-d065-4342-9eb1-6c96f5218eaa/10c156b0-cfb7-41b2-bc2e-33e047d89cc1/67e6409405be681717076516" />
      <Analytics />
      {sections.map((Section, index) => (
        <div key={index} className="section min-h-screen flex items-center justify-center">
          {Section}
        </div>
      ))}
    </div>
  );
};

export default FullPageScroll;
